module.exports = __webpack_public_path__ + "img/icon2.797a4f45.png";